"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addError = exports.formatErrorsKey = void 0;
/**
 * Formats the key for error messages.
 *
 * @param propertyName - The name of the property.
 * @param index - The index of the property (optional).
 * @returns The formatted key for error messages.
 */
function formatErrorsKey(propertyName, index) {
    if (!propertyName) {
        return null;
    }
    else if (index == null) {
        return propertyName.toString();
    }
    else {
        return `${propertyName.toString()}[${index}]`;
    }
}
exports.formatErrorsKey = formatErrorsKey;
/**
 * Adds an error message to the specified property in the validation errors object.
 * @param propertyName - The name of the property to add the error to.
 * @param error - The error message to add.
 * @param errors - The validation errors object.
 */
function addError(propertyName, error, errors) {
    if (!errors)
        return;
    errors[propertyName] ?? (errors[propertyName] = []);
    errors[propertyName].push(error);
}
exports.addError = addError;
//# sourceMappingURL=validation-product-price.util.js.map